import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pcp-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.scss'],
    standalone: true
})
export class ResetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
